import React from 'react';

import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { DummyRoute, PrivateRoute, PublicRoute } from 'routes';

import { Splash } from 'components';
import {
  NotFoundScene,
  LoginScene,
  LogoutScene,
  UserActivationScene,
  UserPasswordConfirmScene,
  TokenCancellationScene
} from 'scenes';

import {
  FirmwareListContainer,
  FirmwareContainer,
  ClinicListContainer,
  ClinicContainer,
  DeviceListContainer,
  DeviceContainer,
  SensorListContainer,
  SensorContainer,
  ChangelogContainer,
  ClinicUserListContainer,
  ClinicHorseListContainer,
  ClinicInvoiceListContainer,
  ClinicExamenListContainer,
  ClinicHorseContainer,
  HorseContainer,
  ExamenContainer,
  HorseListContainer,
  InvoiceListContainer,
  ClinicExamenContainer,
  DashboardContainer
} from 'containers';

import { EnumChannel } from 'enums';

import { Auth } from 'services';

import 'semantic-ui-css/semantic.min.css'
import 'styles/colors.css';
import 'styles/main.css';
import 'styles/theme.css';

class App extends React.Component {

  constructor() {
    super();

    this.state = {
      isTokenChecked: undefined
    };

    Auth.checkToken()
    .finally(() => {
      this.setState({ isTokenChecked: true });
    })
  }

  render() {

    let redirect = <Redirect from="/" to="/login" exact/>;

    if(Auth.isLogged())
    {
      switch (true) {

        case Auth.hasRole(Auth.ROLE_MANAGER):
          redirect = <Redirect from="/" to="/dashboard" exact />;
          break;

        case Auth.hasRole(Auth.ROLE_CLINIC):
          redirect = <Redirect from="/" to="/clinics/users" exact />;
          break;

        default:
          redirect = <Redirect to="/logout" />
          break;
      }

      console.log(redirect);

    }


    return (
      <Router>

        {this.state.isTokenChecked &&
          <Switch>

            {/* Login route */}
            <DummyRoute path="/login" exact component={LoginScene} />

            {/* Logout route */}
            <DummyRoute path="/logout" exact component={LogoutScene} />

            {/* Redirect */}
            {redirect}

            {/* ## MANAGER ## */}

            {/* Firmwares list */}
            <PrivateRoute path="/firmwares" exact component={FirmwareListContainer} />

            {/* Firmware */}
            <PrivateRoute path={`/firmwares/:channel(${EnumChannel.values.join('|')})/:version(\\d+\\.\\d+\\.\\d+)`} exact component={FirmwareContainer} roles={Auth.ROLE_MANAGER} />

            {/* Clinics list */}
            <PrivateRoute path="/clinics" exact component={ClinicListContainer} roles={Auth.ROLE_MANAGER} />

            {/* Clinic details */}
            <PrivateRoute path="/clinics/:clinic(\d+)" exact component={ClinicContainer} roles={Auth.ROLE_MANAGER} />

            {/* Device list */}
            <PrivateRoute path="/devices" exact component={DeviceListContainer} roles={Auth.ROLE_MANAGER} />

            {/* Device details */}
            <PrivateRoute path="/devices/:device(\d+)" exact component={DeviceContainer} roles={Auth.ROLE_MANAGER} />

            {/* Sensor list */}
            <PrivateRoute path="/sensors" exact component={SensorListContainer} roles={Auth.ROLE_MANAGER} />

            {/* Sensor details */}
            <PrivateRoute path="/sensors/:sensor([0-9A-F]{12})" exact component={SensorContainer} roles={Auth.ROLE_MANAGER} />

            {/* Changelog */}
            <PrivateRoute path="/changelogs" exact component={ChangelogContainer} roles={Auth.ROLE_MANAGER} />

            {/* User activation */}
            <PublicRoute path="/users/activate" exact component={UserActivationScene} headless />

            {/* User password confirmation */}
            <PublicRoute path="/users/password/confirm" exact component={UserPasswordConfirmScene} headless />

            {/* User password confirmation */}
            <PublicRoute path="/users/password/abort" exact component={TokenCancellationScene} headless />

            {/* Horse List */}
            <PrivateRoute path="/horses" exact component={HorseListContainer} roles={Auth.ROLE_MANAGER} />

            {/* Horse details */}
            <PrivateRoute path="/horses/:horse" exact component={HorseContainer} roles={Auth.ROLE_MANAGER} />

            {/* Horse List */}
            <PrivateRoute path="/invoices" exact component={InvoiceListContainer} roles={Auth.ROLE_MANAGER} />

            {/* Examen details */}
            <PrivateRoute path="/examens/:examen" exact component={ExamenContainer} roles={Auth.ROLE_MANAGER} />

            {/* ## CLINIC ## */}

            {/* Clinic users */}
            <PrivateRoute path="/clinics/users" exact component={ClinicUserListContainer} roles={Auth.ROLE_CLINIC} />

            {/* Clinic horse list */}
            <PrivateRoute path="/clinics/horses" exact component={ClinicHorseListContainer} roles={Auth.ROLE_CLINIC} />

            {/* Clinic invoice list */}
            <PrivateRoute path="/clinics/invoices" exact component={ClinicInvoiceListContainer} roles={Auth.ROLE_CLINIC} />

            {/* Clinic examen list */}
            <PrivateRoute path="/clinics/examens" exact component={ClinicExamenListContainer} roles={Auth.ROLE_CLINIC} />

            {/* Clinic horse */}
            <PrivateRoute path="/clinics/horses/:horse" exact component={ClinicHorseContainer} roles={Auth.ROLE_CLINIC} />

            {/* Clinic examen details */}
            <PrivateRoute path="/clinics/horses/examens/:examen" exact component={ClinicExamenContainer} roles={Auth.ROLE_CLINIC} />

            {/* Dashboard */}
            <PrivateRoute path="/dashboard" exact component={DashboardContainer} roles={Auth.ROLE_MANAGER} />

            {/* ## DEFAULT ## */}

            {/* NotFound route */}
            <DummyRoute component={NotFoundScene} />

          </Switch>
        }

        <Splash message="Vérification du jeton de connexion" visible={!this.state.isTokenChecked} />
      </Router>
    );
  }
}

export default App;
